import React from 'react';
import { clientPaths } from 'Consts/Strings';
import { useLogoutContext } from 'Context/LogoutContext';
import {
  ReferralPageNavButton,
} from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/ReferralPageNavButton';
import { NavButton } from '../NavButton';
import { PlanningNavButton } from '../HydratedNavButtons/Planning';
import { InvestmentsNavButton } from '../HydratedNavButtons/Investments';
import { MessagesNavButton } from '../HydratedNavButtons/Messages';
import { ProfileNavButton } from '../HydratedNavButtons/Profile';

export const DrawerClientNavCPC = () => {
  const { logout } = useLogoutContext();
  return (
    <>
      <NavButton value="dashboard" to={clientPaths.dashboard} label="Dashboard" />
      <PlanningNavButton />
      <InvestmentsNavButton />
      <MessagesNavButton />
      <ReferralPageNavButton />
      <ProfileNavButton hideAvatar />
      <NavButton value="logout" onClick={logout} label="Logout" />
    </>
  );
};
